const commonRoutes = {
  dashboard: "/admin/dashboard",
  default: "/deliveries/orders",
  login: "/welcome/login",
  newUser: "/welcome/newUser"
};

export default commonRoutes;
